export * from '../../es/entry/mainAny'



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/main/esm/index.js
// module id = null
// module chunks = 